export const delayMsPromise = (timeToDelay) => {
    return new Promise(resolve => {
        setTimeout(resolve, timeToDelay)
    })
}

export const isInt = (n) => {
	return n >>> 0 === parseFloat(n);
}